<template>
  <main class="personal-data">
    <h1>{{$t(title)}}</h1>
    <div class="personal-data__container" id="accordion">
      <div class="personal-data__left-content">
        <router-link to="/account/personal-data" active-class="personal-data__btn__active" class="gui-btn personal-data__btn" v-t="'account.personal-data'" v-if="permissions.CAN_VIEW_ACCOUNT || permissions.CAN_VIEW_ADMIN"/>
        <router-link to="/account/contractor" active-class="personal-data__btn__active" class="gui-btn personal-data__btn" v-t="'account.contractor'"/>
        <router-link to="/account/accreditation" active-class="personal-data__btn__active" class="gui-btn personal-data__btn" v-t="'account.accreditation'" v-if="permissions.CAN_USE_ACCREDITATION"/>
        <router-link to="/account/accreditation-history" active-class="personal-data__btn__active" class="gui-btn personal-data__btn" v-t="'account.accreditation-history'" v-if="permissions.CAN_USE_ACCREDITATION"/>
        <router-link to="/account/digital-signature" active-class="personal-data__btn__active" class="gui-btn personal-data__btn" v-t="'account.digital-signature'" v-if="permissions.CAN_ADD_DIGITAL_SIGNATURE"/>
      </div>
      <div class="personal-data__right-content">
        <router-view></router-view>
      </div>
    </div>
  </main>
</template>

<script>
  export default {
    name: 'personal-data-page',

    computed: {
      permissions() {
        return this.$store.getters.currentUser.permissions;
      },
      title() {
        return this.$route.meta.title;
      }
    }
  }
</script>

<style scoped>

</style>
